import { useAxios } from '../utils/axiosConfig';
import config from '../contexts/ConfigContext';

interface TileModel {
    Title: string;
    Total: number;
    Color: string;
}

class TileService {
    axios = useAxios();
    async GetTiles( startDate: Date, endDate: Date): Promise<TileModel[]> {
        try {
            const response = await this.axios.get(`${config.API_LABELING_URL}/api/Tiles?startDate=${startDate.toDateString()}&endDate=${endDate.toDateString()}`);
            return response.data;
        } catch (error) {
            // Handle error
            console.error('Error fetching tiles:', error);
            return [];
        }
    }
}

export default TileService;